module.exports = "pegasus/assets/active-row-border-top.png";